// Quotation States

export default {
  quotationList: [],
  quotationInfo: {}
}
